import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { QKeyBinder } from '@app/hcs-frontend';
import { ComponentSync, ModuleFE_Dialog } from '@nu-art/thunderstorm-frontend/index';
import * as React from 'react';
const arr = [0, 1, 2, 3];
export class TestDialog extends ComponentSync {
    deriveStateFromProps(nextProps) {
        const refs = arr.map((i) => {
            return { ref: React.createRef(), key: `button-${i}` };
        });
        return { buttonRefs: refs, shiftKeyDown: false };
    }
    render() {
        return (_jsxs("div", { className: 'test-dialog', children: [_jsxs("div", { className: 'test-dialog__header', children: [_jsx("span", { children: "Test Dialog" }), _jsx("div", { className: 'exit-button', onClick: () => ModuleFE_Dialog.close(), children: "Close Dialog" })] }), _jsx(QKeyBinder, { className: 'test-dialog__content', id: 'test-dialog', children: arr.map((i) => {
                        const key = this.state.buttonRefs[i].key;
                        return _jsx("div", { className: 'indexed-button', tabIndex: 0, children: `button ${i}` }, key);
                    }) })] }));
    }
}
